import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { useVagasNavegacao } from '../hooks';
import { useVagasListagem } from '../hooks';
import ProcessosEncerradosHeader from './ProcessosEncerradosHeader';
import ProcessosEncerradosTable from './ProcessosEncerradosTable';
import ProcessosEncerradosFilter from './ProcessosEncerradosFilter';

const ProcessosEncerradosCard = ({
  id,
  showActions = false,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    setPaginaAtual,
    setQuantidadePorPagina
  } = useVagasListagem(id);
  const {
    handleRowClick,
    handleAdicionar,
    handleEditar
  } = useVagasNavegacao();
  return <>
    <Card>
      <CardBody>
        {showHeader && <ProcessosEncerradosHeader totalRegistros={totalRegistros} onAdicionar={showActions ? handleAdicionar : undefined} />}

        {showFilter && <ProcessosEncerradosFilter loading={filterLoading} onApply={handleFilterApply} onLimpar={handleLimparFiltros} />}

        <ProcessosEncerradosTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          manualPagination={true}
          totalRegistros={totalRegistros}
          controlledPagination={
            {
              pageIndex: Math.max(0, (paginaAtual || 1) - 1),
              pageSize: quantidadePorPagina || 10
            }
          } 
          onPaginationChange={next => {
            if (next && typeof next.pageSize === 'number') setQuantidadePorPagina(next.pageSize);
            if (next && typeof next.pageIndex === 'number') setPaginaAtual(next.pageIndex + 1);
          }} />
      </CardBody>
    </Card>
  </>;
};

export default ProcessosEncerradosCard;
